<template>
  <district-blank-form
    submit-label="Сохранить"
    v-bind="$attrs"
    form-type="edit"
    :errors="errors"
    @submit="processForm"
  />
</template>

<script>
import helpers from '@/helpers'
import { updateDistrict } from '@/services/district.service'
import districtBlankForm from '@/components/forms/district/DistrictBlankForm'

export default {
  name: 'district-edit-form',
  components: { districtBlankForm },
  inheritAttrs: false,
  data () {
    return {
      errors: {
        district: {
          id: [],
          name: [],
          city: []
        },
        non_field_errors: []
      }
    }
  },
  methods: {
    fillErrors: helpers.fillErrors,

    processForm () {
      this.updateDistrict().then((success) => {
        if (success) {
          this.showMsg('Информация о районе была успешно обновлена!', 'success', 'Успешно')
          this.$emit('after', true)
        } else {
          this.$emit('after', false)
        }
      })
    },
    updateDistrict () {
      return updateDistrict(this.$attrs.district).then((response) => {
        this.fillErrors(this.errors.district, {})
        return true
      }).catch(err => {
        this.fillErrors(this.errors.district, err.response.data)

        if (this.errors.non_field_errors[0]) {
          this.$parent.$parent.showPopupMsg(this.errors.non_field_errors[0], 'error')
        }

        return false
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// DistrictEditForm.vue?b96266d4